module.exports = __webpack_public_path__ + "img/footpre.aabe9e19.jpg";